import { render, staticRenderFns } from "./about-helper-components-2-header.vue?vue&type=template&id=53d76e12&scoped=true&"
import script from "./about-helper-components-2-header.vue?vue&type=script&lang=ts&"
export * from "./about-helper-components-2-header.vue?vue&type=script&lang=ts&"
import style0 from "./about-helper-components-2-header.vue?vue&type=style&index=0&id=53d76e12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d76e12",
  null
  
)

export default component.exports